import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Clear from "@material-ui/icons/Clear";
import Delete from "@material-ui/icons/Delete";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogAppBar from "../../../Components/DialogAppBar";
import { formatGoogleDriveMediaLink } from "../../../Utils/Common";

import TagNameSearchAutocomplete from "../../../Components/TagNameSearchAutocomplete";
import DetailTabs from "../../../Views/DeviceDetails/DetailTabs";
import PackageDialog from "../EditStockItemDialog/PackageDialog";
import ShippingInformationTab from "../ShippingInformationTab";
import SupplierCompanyTab from "../SupplierCompanyTab";
import WarehouseTab from "../WarehouseTab";

export default function AddStockItemDialog({ open, close, addStockQuantity }) {
  const [editedValues, setEditedValues] = useState();
  const [editPackage, setEditPackage] = useState();
  const [selectedWarehouse, setSelectedWarehouse] = useState();
  const [tagList, setTagList] = useState([]);
  const [autocompKey, setAutocompKey] = useState("sfsadfas");
  const { t } = useTranslation();

  const getMap = () => {
    if (editedValues && editedValues?.Tags) {
      return [...editedValues?.Tags];
    }
    return [];
  };

  const handleExit = () => {
    setTagList([]);
    setSelectedWarehouse();
    setEditPackage();
    setEditedValues();
    close();
  };

  const checkForm = (vals) => {
    const requiredFields = [
      { key: "sku", type: "string" },
      { key: "name", type: "string" },
      { key: "total", type: "number" },
      { key: "warehouse", type: "string" },
    ];
    for (let index = 0; index < requiredFields.length; index++) {
      const element = requiredFields[index];
      if (
        (element.type === "string" && !vals[element.key]) ||
        (element.type === "number" && isNaN(vals[element.key]))
      ) {
        alert("Field " + t("stockModule." + element.key) + " is required!");
        return;
      }
    }
    addStockQuantity({ ...vals });
  };

  return (
    <Dialog open={open} onClose={handleExit} fullScreen>
      <PackageDialog
        pack={editPackage}
        setPack={setEditPackage}
        _edit={editedValues}
        _setEdit={setEditedValues}
      />
      <DialogContent>
        <DialogAppBar
          header={t("stockModule.addNewItem")}
          onClose={handleExit}
        />
        <Grid container spacing={2} style={{ marginTop: 60 }}>
          <Grid container spacing={1} item xs={12} sm={6}>
            <Grid item xs={12}>
              {editedValues?.imageUrl ? (
                <>
                  <img
                    alt={editedValues?.name + "-image"}
                    src={formatGoogleDriveMediaLink(editedValues.imageUrl)}
                    style={{ width: 200 }}
                  />
                  <IconButton
                    onClick={() => {
                      setEditedValues({ ...editedValues, imageUrl: null });
                    }}
                  >
                    <Delete />
                  </IconButton>
                </>
              ) : (
                <TextField
                  variant="outlined"
                  label={"Image URL"}
                  placeholder="Add image url e.g. from Google Drive"
                  fullWidth
                  onChange={(e, v) => {
                    setEditedValues({
                      ...editedValues,
                      imageUrl: e.target.value,
                    });
                  }}
                ></TextField>
              )}
            </Grid>
          </Grid>
          <Grid container item xs={12} sm={6} spacing={1}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label={"SKU"}
                required
                onChange={(e) => {
                  setEditedValues({ ...editedValues, sku: e.target.value });
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                variant="outlined"
                label={t("stockModule.name")}
                onChange={(e) => {
                  setEditedValues({ ...editedValues, name: e.target.value });
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                type="number"
                inputProps={{ min: 0 }}
                label={t("stockModule.listPrice")}
                onChange={(e, v) => {
                  setEditedValues({
                    ...editedValues,
                    listPrice: e.target.value,
                  });
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                type="number"
                inputProps={{ min: 0 }}
                label={t("stockModule.costPrice")}
                onChange={(e, v) => {
                  setEditedValues({
                    ...editedValues,
                    costPrice: e.target.value,
                  });
                }}
              ></TextField>
            </Grid>
            <Grid item xs={12}>
              <>
                {editedValues && editedValues?.Tags
                  ? getMap().map((ta, i) => (
                      <Grid key={i} item style={{ margin: "6px" }}>
                        <Button
                          style={{
                            fontSize: 12,
                            textAlign: "center",
                            backgroundColor: "lightgrey",
                            padding: 3,
                            borderRadius: 10,
                            zIndex: 9999,
                          }}
                          onClick={(e) => {
                            setEditedValues({
                              ...editedValues,
                              Tags: editedValues.Tags.filter((tt) => tt !== ta),
                            });
                          }}
                          endIcon={<Clear />}
                        >
                          {ta}
                        </Button>
                      </Grid>
                    ))
                  : null}
              </>
              <TagNameSearchAutocomplete
                onChange={(e, v) => {
                  if (v && v.name) {
                    var arr = editedValues?.Tags || [];
                    arr.push(v.name);
                    setEditedValues({ ...editedValues, Tags: [...arr] });
                    setAutocompKey(Date.now());
                  }
                }}
                reset={autocompKey}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <DetailTabs
              activeTabs={[
                {
                  label: t("stockModule.warehouse"),
                  content: (
                    <WarehouseTab
                      setEditedValues={setEditedValues}
                      editedValues={editedValues}
                      setSelectedWarehouse={setSelectedWarehouse}
                      selectedWarehouse={selectedWarehouse}
                      onlyEditableWarehouses={true}
                      newItem={true}
                    />
                  ),
                },
                {
                  label: t("stockModule.supplierCompany"),
                  content: (
                    <SupplierCompanyTab
                      setEditedValues={setEditedValues}
                      editedValues={editedValues}
                      selectedWarehouse={selectedWarehouse}
                      newItem={true}
                    />
                  ),
                },
                {
                  label: t("stockModule.shippingInformation"),
                  content: (
                    <ShippingInformationTab
                      setEditedValues={setEditedValues}
                      editedValues={editedValues}
                      setEditPackage={setEditPackage}
                      selectedWarehouse={selectedWarehouse}
                      newItem={true}
                    />
                  ),
                },
              ]}
            />
          </Grid>

          <Grid item style={{ marginBottom: 100 }}>
            <Button
              variant="contained"
              disabled={!editedValues}
              color="primary"
              onClick={() => {
                checkForm(editedValues);
              }}
            >
              {t("submit")}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
